export default "__VITE_ASSET__D$nCnljA__"